const Level5 = ({
  currentImage,
  L0OuterL2,
  L0OuterL3,
  L0OuterL4,
  L0OuterL6,
  L5Business,
  L5Core,
  L5Leadership,
  L5Self,
}) => {
  return (
    <div className={`${currentImage !== "imagedivl5" ? "hidden" : ""}`}>
      <div className="" id="imagedivl5">
        <div>
          <img
            src="assets/images/outerL5 1.png"
            useMap="#lw05"
            className="w-80 h-80"
            alt=""
          />
          <map name="lw05" id="lw05">
            <area
              className="cursor-pointer"
              alt="L5 Outer L6"
              onClick={L0OuterL6}
              coords="862,194,929,89,1063,194,1161,329,1215,479,1228,617,1104,616,1082,471,997,315"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L5 Outer L2"
              onClick={L0OuterL2}
              coords="773,25,617,3,432,29,261,118,335,214,452,151,619,125,768,155,900,221,988,129,893,69"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L5 Outer L3"
              onClick={L0OuterL3}
              coords="149,436,116,625,168,841,72,891,29,785,8,674,7,520,57,354,158,209,245,290"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L5 Outer L4"
              onClick={L0OuterL4}
              coords="43,837,147,789,265,969,460,1081,612,1109,614,1216,433,1197,241,1097,117,963"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L5 Business"
              onClick={L5Business}
              coords="610,615,1098,619,1065,795,954,963,786,1068,616,1100"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L5 Core"
              onClick={L5Core}
              coords="613,128,613,622,1102,617,1064,436,996,316,889,215,758,152,680,137,613,126"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L5 Leadership"
              onClick={L5Leadership}
              coords="614,128,411,168,224,307,139,486,120,616,402,616,615,615,614,381,615,242"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L5 Self"
              onClick={L5Self}
              coords="125,617,612,617,612,1103,470,1083,311,1005,182,864,133,717"
              shape="poly"
            />
          </map>
        </div>
      </div>
    </div>
  );
};

export default Level5;
